import { toast } from 'react-toastify'
import URL from 'src/apis/URL'

export const sendWhatsAppRequest = () => ({
  type: 'SEND_WHATSAPP_REQUEST',
})

export const sendWhatsAppSuccess = (response) => ({
  type: 'SEND_WHATSAPP_SUCCESS',
  payload: response,
})

export const sendWhatsAppFailure = (error) => ({
  type: 'SEND_WHATSAPP_FAILURE',
  error,
})

export const sendWhatsAppMessage = (payload) => {
  return (dispatch) => {
    dispatch(sendWhatsAppRequest())

    fetch(URL.BASE_URL + URL.END_POINT.sendwhatsapp, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        Accept: 'application/json',
      },
      body: JSON.stringify(payload),
    })
      .then(async (response) => {
        if (!response.ok) {
          const message = await response.json().then((res) => res.message)
          throw new Error(message)
        }
        return response.json()
      })
      .then((data) => {
        dispatch(sendWhatsAppSuccess(data))
        toast('Message sent successfully!', { type: 'success' })
      })
      .catch((error) => {
        dispatch(sendWhatsAppFailure(error.message))
        toast(error.message, { type: 'error' })
      })
  }
}

const initialWhatsAppState = {
  loading: false,
  response: null,
  error: null,
}

export const sendWhatsAppReducer = (state = initialWhatsAppState, action) => {
  switch (action.type) {
    case 'SEND_WHATSAPP_REQUEST':
      return { ...state, loading: true, error: null }
    case 'SEND_WHATSAPP_SUCCESS':
      return { ...state, loading: false, response: action.payload, error: null }
    case 'SEND_WHATSAPP_FAILURE':
      return { ...state, loading: false, error: action.error }
    default:
      return state
  }
}
